import React, { useEffect, useState } from "react";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { IModel, IWorkStream } from "./WorkStreamList";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tooltip } from "primereact/tooltip";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { Button } from "primereact/button";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import WorkStreamDocument from "./WorkStreamDocument";
import { Dialog } from "primereact/dialog";
import WorkStreamStatus from "./WorkStreamStatus";
import WorkStreamHistory from "./WorkStreamHistory";
import { Accordion, AccordionTab } from "primereact/accordion";
import Filter, { IWorkStreamFilter } from "./Filter";
import { Toolbar } from "primereact/toolbar";
interface IProps {
  permission: IPermissionProps;
  setModal: (modal: IModel) => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
}

const Table = (props: IProps) => {
  const [tableData, setTableData] = useState<IWorkStream[]>([]);
  const [loading, setLoading] = useState(false);
  const [openFile, setOpenFile] = useState(false);
  const [descriptionDialog, setDescriptionDialog] = useState<{ visible: boolean; description: string }>({ visible: false, description: "" });
  const [rfpDescriptionDialog, setRFPDescriptionDialog] = useState<{ visible: boolean; description: string }>({ visible: false, description: "" });
  const [statusDialog, setStatusDialog] = useState(false);
  const [selectedWorkStreamStatus, setSelectedWorkStreamStatus] = useState<any>(null);
  const [selectedWorkStream, setSelectedWorkStream] = useState<IWorkStream | null>(null);
  const [selectedWorkstreamId, setSelectedWorkstreamId] = useState<number | null>(null);
  const [historyModal, setHistoryModal] = useState<boolean>(false);
  const [filter, setFilter] = useState<IWorkStreamFilter>({
    fromDate: null,
    toDate: null,
    deadlineFromDate: null,
    deadlineToDate: null,
    categoryId: null,
    assignedTo: null,
    addedBy: null,
    workstream_Category_ID: 0,
    status: "",
  });
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  let _roles: Array<number> = [];
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });
  const DateFormat = loginObj.date_Format;
  const openEdit = (rowData: IWorkStream) => {
    props.setModal({
      open: true,
      singleData: rowData,
    });
  };

  const loadData = async () => {
    try {
      setLoading(true);

      const filterPayload = {
        fromDate: filter.fromDate,
        toDate: filter.toDate,
        deadlineFromDate: filter.deadlineFromDate,
        deadlineToDate: filter.deadlineToDate,
        categoryId: filter.categoryId,
        assignedTo: filter.assignedTo,
        addedBy: filter.addedBy,
        workstream_Category_ID: filter.workstream_Category_ID,
        status: filter.status,
      };

      const queryParam = `filters=${encodeURIComponent(JSON.stringify(filterPayload))}`;
      const response = await Fetch("TenderWorkstream/GetAllTenderWorkStream", "GET", null, queryParam, props.toast);
      if (response?.ok) {
        const data = await response.json();
        setTableData(data);
      }
    } finally {
      setLoading(false);
    }
  };

  const statusColors: Record<string, string> = {
    Created: "#64748B",
    Assigned: "#3B82F6",
    Pending: "#F59E0B",
    Received: "#8B5CF6",
    "Under Review": "#F97316",
    "Documentation Pending": "#EAB308",
    Completed: "#22C55E",
    Rejected: "#EF4444",
    Closed: "#475569",
  };

  const getCanChangeStatus = (rowData: IWorkStream): boolean => {
    if (_roles.includes(1) || _roles.includes(26) || _roles.includes(56)) {
      // Admin / super roles - always allowed
      return true;
    }

    if (rowData !== null && (rowData?.status === "Uploaded" || rowData?.status === "Verified" || rowData?.status === "Non-Compliant") && _roles.includes(55)) {
      // Proposal-Writer
      return true;
    } else if (rowData !== null && (rowData?.status === "Verified" || rowData?.status === "Approved" || rowData?.status === "Rejected") && _roles.includes(53)) {
      // Bid-Manager
      return true;
    } else if (rowData !== null && rowData?.status === "Approved" && rowData.assigned_To_ID !== undefined && rowData.assigned_To_ID !== null && rowData.assigned_To_ID > 0 && rowData.assigned_To_ID === loginObj.id) {
      return true;
    } else if (rowData !== null && rowData?.status !== "Closed" && rowData?.status !== "Uploaded" && rowData?.status !== "Verified" && rowData?.status !== "Approved" && rowData?.assigned_To_ID !== undefined && rowData?.assigned_To_ID !== null && rowData?.assigned_To_ID > 0 && rowData.assigned_To_ID === loginObj.id) {
      return true;
    }

    return false;
  };

  const workStreamStatus = (rowData: IWorkStream) => {
    const dotColor = statusColors[rowData.status ?? ""] || "#64748B";
    // const canChangeStatus = _roles.includes(1) || _roles.includes(26) || (!_roles.includes(53) && !_roles.includes(54) && !_roles.includes(55)) || (_roles.includes(55) && rowData.workstream_Category_ID === 3) || (_roles.includes(54) && rowData.workstream_Category_ID === 6);
    // const canChangeStatus = (_roles.includes(1) || _roles.includes(26) || !(_roles.includes(53) && _roles.includes(54)));
    const canChangeStatus = getCanChangeStatus(rowData);
    return (
      <span
        style={{ color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}
        onClick={() => {
          if (canChangeStatus) {
            setSelectedWorkStreamStatus(rowData);
            setStatusDialog(true);
          } else {
            props.toast.current.show({ severity: "warn", detail: "You are not authorized to perform this action.", life: 3000 });
          }
        }}
      >
        <i className="pi pi-circle-fill" style={{ color: dotColor, fontSize: "0.6rem", marginRight: "10px" }} />
        {rowData.status}
      </span>
    );
  };
  const openFileUpload = (rowData: IWorkStream) => {
    setSelectedWorkStream(rowData);
    setOpenFile(true);
  };
  const actionBody = (rowData: IWorkStream) => {
    return (
      <>
        <div className="flex gap-2">
          {(_roles.includes(1) || _roles.includes(26) || _roles.includes(55) || _roles.includes(56)) && rowData?.status !== "Closed" && <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" onClick={() => openEdit(rowData)} tooltip="Edit" tooltipOptions={{ position: "top" }} />}
          <Button icon="pi pi-cloud-upload" className="p-button-rounded p-button-success" onClick={() => openFileUpload(rowData)} tooltip="Upload Document" tooltipOptions={{ position: "top" }} />
        </div>
      </>
    );
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.reload, filter]);

  const openHistory = (workstreamId: number) => {
    setSelectedWorkstreamId(workstreamId);
    setHistoryModal(true);
  };

  const downloadBody = (rowData: any) => {
    return rowData.referenceDocument ? <Button icon="pi pi-download" className="p-button-rounded p-button-success p-button-text" tooltip="Download" onClick={() => downloadDoc(rowData.id)} /> : null;
  };

  const downloadDoc = async (documentID: number) => {
    const params = {
      method: "GET",
      headers: {
        "Content-Type": "application/octet-stream",
        Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
      },
    };
    try {
      const response = await fetch(`${baseUrl}TenderWorkstream/WorkstreamReferanceDocDownload?documentID=${documentID}`, params);

      if (response.status === 200) {
        const blob = await response.blob();

        const disposition = response.headers.get("content-disposition");
        let fileName = "WorkStream_Master_Document";

        if (disposition) {
          const match = disposition.match(/filename="?([^"]+)"?/);
          if (match?.[1]) {
            fileName = match[1];
          }
        }

        const href = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = href;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(href);
      }
    } catch {
      props.toast?.current?.show({ severity: "error", summary: "Error", detail: "Something went wrong", life: 3000 });
    }
  };

  const leftToolbarTemplate = () => {
    return (
      <>
        <div className="flex align-items-center gap-3">
          <Button
            icon="pi pi-refresh"
            className="p-button-rounded p-button-info mr-2"
            onClick={() =>
              setFilter({
                fromDate: null,
                toDate: null,
                deadlineFromDate: null,
                deadlineToDate: null,
                categoryId: null,
                assignedTo: null,
                addedBy: null,
                workstream_Category_ID: 0,
                status: "",
              })
            }
          />
          <small className="text-500 flex align-items-center">
            <i className="pi pi-info-circle mr-2" />
            Refresh the list after document upload to view the latest updates.
          </small>
        </div>
      </>
    );
  };

  return (
    <>
      <Toolbar left={leftToolbarTemplate} className="mb-3" />
      <Accordion>
        <AccordionTab header="Filter">
          <Filter filter={filter} setFilter={setFilter} />
        </AccordionTab>
      </Accordion>
      <DataTable value={tableData} loading={loading} stripedRows showGridlines responsiveLayout="scroll" header="Work Stream List">
        <Column header="SN." body={(r, o) => o.rowIndex + 1} />

        <Column field="client_Category" header="RFP Client Category" />
        <Column field="vendor_Company" header="RFP Client" />
        <Column field="tender_Client" header="RFP Client POC" />
        <Column field="tender_Title" header="RFP Title" />
        <Column field="service_Department_Name" header="RFP Service Department" />
        <Column
          field="rfP_Description"
          header="RFP Description"
          body={(rowData: any) =>
            rowData.description ? (
              <>
                <Tooltip target=".view-description" />
                <i className="pi pi-eye view-description cursor-pointer" data-pr-tooltip="View Description" data-pr-position="top" style={{ color: "var(--primary-color)", fontSize: "1.2rem" }} onClick={() => setRFPDescriptionDialog({ visible: true, description: rowData.rfP_Description || "" })} />
              </>
            ) : (
              "-"
            )
          }
        />
        <Column field="tender_Published_Date" header="RFP Published Date" body={(rowData: any) => safeFormatDate(rowData.tender_Published_Date, "dd/MM/yy", DateFormat)} style={{ maxWidth: "120px" }} />
        <Column field="due_Date" header="RFP Due Date" body={(rowData: any) => safeFormatDate(rowData.due_Date, "dd/MM/yy", DateFormat)} style={{ maxWidth: "120px" }} />
        <Column field="assigned_ToBM" header="RFP Bid Manager" />
        <Column field="assigned_To_Pro" header="RFP Proposal Writer" />
        <Column field="category_Name" header="Workstream Category" />
        <Column field="title" header="Workstream Title" />
        <Column field="rfP_Number" header="RFP Number" body={(rowData) => <span style={{ background: "#eff6ff", color: "#1d4ed8", padding: "4px 8px", borderRadius: "5px", fontWeight: 600, fontSize: "12px" }}>{rowData.rfP_Number ?? "-"}</span>} />
        <Column
          header="Workstream Description"
          body={(rowData: IWorkStream) =>
            rowData.description ? (
              <>
                <Tooltip target=".view-description" />

                <i
                  className="pi pi-eye view-description cursor-pointer"
                  data-pr-tooltip="View Description"
                  data-pr-position="top"
                  style={{ color: "var(--primary-color)", fontSize: "1.2rem" }}
                  onClick={() =>
                    setDescriptionDialog({
                      visible: true,
                      description: rowData.description || "",
                    })
                  }
                />
              </>
            ) : (
              "-"
            )
          }
        />
        <Column header="Reference Document" body={downloadBody} />
        <Column header="Status" body={workStreamStatus} style={{ minWidth: "180px" }} />
        <Column field="assigned_To" header="Assigned To" />
        <Column field="assigned_By" header="Assigned By" />
        <Column field="deadline_Date" header="Deadline Date" body={(rowData: any) => safeFormatDate(rowData.deadline_Date, "dd/MM/yy", DateFormat)} style={{ maxWidth: "120px" }} />
        <Column field="assigned_At" header="Assigned At" body={(rowData: any) => safeFormatDate(rowData.assigned_At, "dd/MM/yyyy", DateFormat)} />
        <Column field="added_By" header="Added By" />
        <Column field="added_On" header="Added On" body={(rowData: any) => safeFormatDate(rowData.added_On, "dd/MM/yyyy", DateFormat)} />
        <Column
          header="History"
          body={(rowData: IWorkStream) => (
            <span className="cursor-pointer" onClick={() => openHistory(rowData.id || 0)}>
              <i className="pi pi-history" style={{ color: "var(--primary-color)" }} />
            </span>
          )}
        />
        <Column header="Action" body={actionBody} style={{ width: "90px" }} />
      </DataTable>
      <WorkStreamDocument showForm={true} visible={openFile} onHide={() => setOpenFile(false)} workStream={selectedWorkStream} toast={props.toast} />
      <Dialog header="Description" visible={descriptionDialog.visible} modal style={{ width: "40vw" }} onHide={() => setDescriptionDialog({ visible: false, description: "" })}>
        <p style={{ whiteSpace: "pre-wrap" }}>{descriptionDialog.description}</p>
      </Dialog>
      {/* Work Stream Status */}
      <WorkStreamStatus
        visible={statusDialog}
        workStream={selectedWorkStreamStatus}
        toast={props.toast}
        onHide={() => {
          setStatusDialog(false);
          setSelectedWorkStreamStatus(null);
        }}
        onSuccess={() => {
          props.setReload(!props.reload);
        }}
      />
      {/* Workstream Histroy */}
      <WorkStreamHistory
        visible={historyModal}
        workstreamId={selectedWorkstreamId}
        toast={props.toast}
        onHide={() => {
          setHistoryModal(false);
          setSelectedWorkstreamId(null);
        }}
      />
      <Dialog header="RFP Description" visible={rfpDescriptionDialog.visible} modal style={{ width: "40vw" }} onHide={() => setRFPDescriptionDialog({ visible: false, description: "" })}>
        <p style={{ whiteSpace: "pre-wrap" }}>{rfpDescriptionDialog.description}</p>
      </Dialog>
    </>
  );
};

export default Table;
